export default {
  'feedback-module:did-pet-eat-product:title': 'Hat dein Hund / deine Katze das Produkt gefressen?',
  'feedback-module:explanation:dog:subtitle':
    'Dein Feedback hilft uns, das passende Futter für deinen Hund zu finden.',
  'feedback-module:explanation:cat:subtitle':
    'Dein Feedback hilft uns, das passende Futter für deine Katze zu finden.',
  'feedback-module:complete:title:thank-you': 'Vielen Dank!',
  'feedback-module:complete:description':
    'Wir verarbeiten deine Antwort für passendere Futterempfehlungen.',
  'feedback-module:button:no': 'Nein',
  'feedback-module:button:skip': 'Skip',
  'feedback-module:button:yes': 'Ja',
  'feedback-module:image:alt': 'Cat and dog cuddling',
};
